/**
 * Wire shapes for /api/v2/admin/attributes/* (read) and
 * /api/v2/admin/user-group/* (write). Both BE surfaces feed the
 * DoctorProfile attribute stack; we colocate the types here because
 * the consumers always need them together.
 */

// Phase E Cycle 5 canonical (BE system.constants).
export enum AttributePlaceUse {
  Group = 'group',
  DoctorProfile = 'doctor_profile',
  Both = 'both',
  Email = 'email',
  Report = 'report'
}

export enum AttributeGroupPlaceUse {
  DoctorProfile = 'doctor_profile',
  Email = 'email',
  Both = 'both',
  Unknown = 'unknown'
}

export interface Attribute {
  id: number;
  name: string | null;
  slug: string;
  type: string;
  description?: string | null;
}

export interface AttributeGroup {
  id: number;
  slug: string;
  name: string | null;
  place_use: AttributeGroupPlaceUse | null;
  is_editable: boolean | null;
  attributes: Attribute[];
}

/**
 * Body for POST /api/v2/admin/user-group — replaces the user-group
 * attribute rows for (user_id, group_id, lang). Each `values` entry
 * is one row (the array index becomes row_index in storage).
 */
export interface UserGroupAttributesInput {
  user_id: number;
  group_id: number;
  lang: string;
  values: Record<string, string | undefined>[];
}

/**
 * Body for POST /api/v2/admin/user-group/user-attributes —
 * replaces a user's flat attribute map. `lang` is accepted by the
 * DTO post-cycle9 closure but not persisted server-side (legacy
 * parity); we keep it on the wire so a future per-locale schema
 * doesn't need a FE change.
 */
export interface UserAttributesInput {
  user_id: number;
  lang?: string;
  values: Record<string, string | undefined>;
}
